import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { GestaoAdministrativaContent } from './gestao-administrativa-content';
import { MapaPendencias } from '@/features/gestao/gestao-administrativa/mapa-pendencias/mapa-pendencias';
import { MapaBrasil } from '@/features/gestao/gestao-administrativa/mapa-brasil/mapa-brasil';
import { MapaCalor } from '@/features/gestao/gestao-administrativa/mapa-calor/mapa-calor';
import { InconsistenciasCadastro } from '@/features/gestao/gestao-administrativa/inconsistencias-cadastro/inconsistencias-cadastro';
import { EstatisticasCadastro } from '@/features/gestao/gestao-administrativa/estatisticas-cadastro/estatisticas-cadastro';
import { EstatisticasCadastroPrestador } from '@/features/gestao/gestao-administrativa/estatisticas-cadastro-prestador/estatisticas-cadastro-prestador';
import { MedicosAtivosData } from '@/features/gestao/gestao-administrativa/medicos-ativos-data/medicos-ativos-data';
import { PrestadoresAtivosData } from '@/features/gestao/gestao-administrativa/prestadores-ativos-data/prestadores-ativos-data';
import { CadastroGeral } from '@/features/gestao/gestao-administrativa/cadastro-geral/cadastro-geral';
import { CadastroGeralPrestador } from '@/features/gestao/gestao-administrativa/cadastro-geral-prestador/cadastro-geral-prestador';
import { SituacaoMensal } from '@/features/gestao/gestao-administrativa/situacao-mensal/situacao-mensal';
import { ParticipacaoEleitoral } from '@/features/gestao/gestao-administrativa/participacao-eleitoral/participacao-eleitoral';
import { QualidadeMonitoramento } from '@/features/gestao/gestao-administrativa/qualidade-monitoramento/qualidade-monitoramento';
import { ComissoesTecnicas } from '@/features/gestao/gestao-administrativa/comissoes-tecnicas/comissoes-tecnicas';

const rootPath = 'gestao-administrativa';

const breadcrumbEstatisticaCadastro = (route: ActivatedRouteSnapshot): string => {
    const labels: Record<string, string> = {
        evolucao: 'Evolução',
        perfil: 'Perfil',
        endereco: 'Endereço',
        formacao: 'Formação',
        registro: 'Registro',
        transferencia: 'Transferência',
        situacao: 'Situação',
        operacional: 'Operacional',
        qualidade: 'Qualidade',
        especialidade: 'Especialidade',
        vinculos: 'Vínculos'
    };

    const grupo = route.paramMap.get('grupo') ?? '';
    return labels[grupo] ?? grupo;
};

const breadcrumbEstatisticaPrestador = (route: ActivatedRouteSnapshot): string => {
    const labels: Record<string, string> = {
        situacao: 'Situação',
        'perfil-juridico': 'Perfil jurídico',
        localizacao: 'Localização',
        certificados: 'Certificados',
        diretoria: 'Diretoria',
        comissao: 'Comissão',
        servicos: 'Serviços',
        operacional: 'Operacional',
        pendencias: 'Pendências'
    };

    const grupo = route.paramMap.get('grupo') ?? '';
    return labels[grupo] ?? grupo;
};

export const gestaoAdministrativaRoutes: Routes = [
    {
        path: rootPath,
        component: GestaoAdministrativaContent,
        data: { breadcrumb: 'Gestão Administrativa' },
        children: [
            { path: '', component: MapaPendencias },
            { path: 'mapa-pendencias', component: MapaPendencias, data: { breadcrumb: 'Mapa de Pendências' } },
            { path: 'mapa-brasil', component: MapaBrasil, data: { breadcrumb: 'Mapa Controle Cadastro' } },
            { path: 'mapa-calor', component: MapaCalor, data: { breadcrumb: 'Mapa de Calor' } },
            { path: 'medicos-ativos-data', component: MedicosAtivosData, data: { breadcrumb: 'Médicos Ativos por Data' } },
            { path: 'prestadores-ativos-data', component: PrestadoresAtivosData, data: { breadcrumb: 'Prestadores Ativos por Data' } },
            { path: 'cadastro-geral', component: CadastroGeral, data: { breadcrumb: 'Cadastro Geral de Médicos' } },
            { path: 'cadastro-geral-prestador', component: CadastroGeralPrestador, data: { breadcrumb: 'Cadastro Geral de Prestadores' } },
            { path: 'situacao-mensal', component: SituacaoMensal, data: { breadcrumb: 'Situação Mensal' } },
            { path: 'participacao-eleitoral', component: ParticipacaoEleitoral, data: { breadcrumb: 'Participação Eleitoral' } },
            { path: 'qualidade-monitoramento', component: QualidadeMonitoramento, data: { breadcrumb: 'Qualidade e Monitoramento' } },
            { path: 'comissoes-tecnicas', component: ComissoesTecnicas, data: { breadcrumb: 'Câmaras e Comissões Técnicas' } },
            { path: 'inconsistencias-cadastro', component: InconsistenciasCadastro, data: { breadcrumb: 'Mapa de Inconsistências de Cadastro' } },
            {
                path: 'estatisticas-cadastro',
                data: { breadcrumb: 'Estatísticas de Cadastro' },
                children: [
                    { path: '', redirectTo: 'evolucao', pathMatch: 'full' },
                    {
                        path: ':grupo',
                        component: EstatisticasCadastro,
                        resolve: {
                            breadcrumb: breadcrumbEstatisticaCadastro
                        },
                        data: { breadcrumb: null }
                    }
                ]
            },
            {
                path: 'estatisticas-cadastro-prestador',
                data: { breadcrumb: 'Estatísticas de Prestador' },
                children: [
                    { path: '', redirectTo: 'situacao', pathMatch: 'full' },
                    {
                        path: ':grupo',
                        component: EstatisticasCadastroPrestador,
                        resolve: {
                            breadcrumb: breadcrumbEstatisticaPrestador
                        },
                        data: { breadcrumb: null }
                    }
                ]
            }
        ]
    }
];
